import { checkExistingPaymentMethodsAndCreditLine } from './identificationActions';
import { ActionTypes } from '../models/actions/common';

export const clearState = () => ({
  type: ActionTypes.ClearState,
});

export const clearError = () => ({
  type: ActionTypes.ClearError,
});

export const continueExistingApplicationWithConsumerAlert = () => (dispatch: any) => {
  dispatch(clearState());
  dispatch(checkExistingPaymentMethodsAndCreditLine());
};

export type Actions = ReturnType<typeof clearState> | ReturnType<typeof clearError>;
